import { assign } from "xstate";

export const actions = {
  setIsDesktop: assign({
    isDesktop: () => {
      return window.innerWidth > 768;
    },
  }),
};
